import React, { PropTypes, Component } from 'react'
import SelectInput from 'components/Form/components/SelectInput'
import constants from 'constants'
import styles from '../../BankTransferDisplayForm.scss'
import BankAccountForm from './BankAccountForm'

class BankToAccountList extends Component {
  static propTypes = {
    bankTransferForm: PropTypes.object.isRequired,
    bankTransfers: PropTypes.instanceOf(Array),
    bankAccountsSaved: PropTypes.instanceOf(Array),
    form: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleFocus: PropTypes.func.isRequired,
    handleValidation: PropTypes.func.isRequired,
    schema: PropTypes.object.isRequired,
  }

  static defaultProps = {
    bankTransfers: [],
    bankAccountsSaved: [],
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedSavedAccount: '',
      hasTriggeredSavedAccountChange: false,
    }
  }

  getSavedBankAccountOptions = () => {
    const uniqueOptions = {}
    this.props.bankAccountsSaved
      .filter(accounts => accounts.TransferRequestType === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.BANK)
      .forEach((accounts) => {
        const toAccountName = accounts.ToAccountName || ''
        const toAccountNumber = accounts.ToAccountNo || ''
        const bankBSB = accounts.ToAccountBSBNo|| ''

        if (!toAccountName && !toAccountNumber) {
          return
        }

        const key = `${toAccountName}|${toAccountNumber}|${bankBSB}`
        if (!uniqueOptions[key]) {
          uniqueOptions[key] = {
            value: key,
            label: `${toAccountName}`,
          }
        }
      })

    const savedOptions = Object.keys(uniqueOptions).map((key, index) => {
      const option = uniqueOptions[key]
      return {
        ...option,
        label: index === 0 ? `${option.label} (Last Used)` : option.label,
      }
    })

    return [
      { value: '__ADD_NEW_ACCOUNT__', label: '+ Add New Account' },
      ...savedOptions,
    ]
  }

  handleSavedAccountChange = (name, value) => {
    this.setState({
      selectedSavedAccount: value,
      hasTriggeredSavedAccountChange: true,
    })

    if (value === '__ADD_NEW_ACCOUNT__') {
      this.props.handleChange('toAccountName', '')
      this.props.handleChange('toAccountNumber', '')
      this.props.handleChange('bankBSB', '')
      return
    }

    if (!value) {
      return
    }

    const [toAccountName, toAccountNumber, bankBSB] = value.split('|')
    this.props.handleChange('toAccountName', toAccountName || '')
    this.props.handleChange('toAccountNumber', toAccountNumber || '')
    this.props.handleChange('bankBSB', bankBSB || '')
  }

  render() {
    const savedBankAccountOptions = this.getSavedBankAccountOptions()

    return (
      <div className={styles.fieldset}>
        {savedBankAccountOptions.length > 0 && (
          <li>
            <SelectInput
              label="Account List"
              name="accountlist"
              searchable
              handleChange={this.handleSavedAccountChange}
              onBlur={() => {}}
              options={savedBankAccountOptions}
              value={this.state.selectedSavedAccount}
            />
          </li>
        )}
        {this.state.hasTriggeredSavedAccountChange && (
          <BankAccountForm
            bankTransferForm={this.props.bankTransferForm}
            form={this.props.form}
            handleChange={this.props.handleChange}
            handleFocus={this.props.handleFocus}
            handleValidation={this.props.handleValidation}
            schema={this.props.schema}
          />
        )}
      </div>
    )
  }
}

export default BankToAccountList



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/components/BankTransfer/BankToAccountList.js